class AudioContextManager {
  private static instance: AudioContext | null = null;

  static async getInstance(): Promise<AudioContext> {
    if (!this.instance) {
      this.instance = new AudioContext();
      await this.instance.resume();
    }
    return this.instance;
  }

  static async playAudioBuffer(buffer: ArrayBuffer): Promise<void> {
    const context = await this.getInstance();
    const audioBuffer = await context.decodeAudioData(buffer);
    const source = context.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(context.destination);
    
    return new Promise((resolve) => {
      source.onended = () => resolve();
      source.start(0);
    });
  }
}

export default AudioContextManager;